import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const NotesIcon = ({
  width = "24",
  height = "24",
  color = "#0860A8",
  secondColor = "#CEDFEE",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="4" fill={secondColor} />
        <path
          d="M6 16V14.6667H14V16H6ZM6 12.6667V11.3333H18V12.6667H6ZM6 9.33333V8H18V9.33333H6Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
